import { alphaWithSpaces, isDateValidOrEmpty, isDateInValidRange, regex, betweenLength } from 'utils/validators';
import { minLength, required, email, maxLength } from 'vuelidate/lib/validators';
var PaymentValidationService = /** @class */ (function () {
    function PaymentValidationService() {
    }
    PaymentValidationService.formValidations = {
        form: {
            passengers: {
                required: required,
                $each: {
                    firstName: { required: required, alphaWithSpaces: alphaWithSpaces },
                    flights: {
                        required: required,
                        $each: {
                            flightDate: {
                                inRange: isDateInValidRange(2, 'years', 'DD / MM / YYYY'),
                                valid: isDateValidOrEmpty('DD / MM / YYYY'),
                                required: required
                            },
                            flightNumber: {
                                required: required,
                                between: betweenLength(3, 6),
                                flightNumberInvalid: regex('flightNumber')
                            },
                            originLabel: {
                                required: required
                            },
                            destinLabel: {
                                required: required
                            }
                        }
                    },
                    lastName: {
                        required: required,
                        alphaWithSpaces: alphaWithSpaces,
                        minLength: minLength(2),
                        maxLength: maxLength(50)
                    }
                }
            },
            contactFirstName: { required: required, alphaWithSpaces: alphaWithSpaces },
            contactLastName: {
                required: required,
                alphaWithSpaces: alphaWithSpaces,
                minLength: minLength(2),
                maxLength: maxLength(50)
            },
            email: { required: required, email: email },
            title: { required: required }
        }
    };
    PaymentValidationService.errorMessages = {
        passengers: {
            required: 'reusable.checked.validation.isTrue'
        },
        firstName: {
            required: 'reusable.firstName.validation.required',
            alphaWithSpaces: 'reusable.firstName.validation.alphaWithSpaces'
        },
        lastName: {
            required: 'reusable.lastName.validation.required',
            alphaWithSpaces: 'reusable.lastName.validation.alphaWithSpaces',
            minLength: 'reusable.lastName.validation.minLength',
            maxLength: 'reusable.lastName.validation.maxLength'
        },
        flights: {
            required: 'reusable.checked.validation.isTrue'
        },
        flightDate: {
            required: 'reusable.flightDate.validation.required',
            valid: 'reusable.flightDate.validation.invalid',
            inRange: 'reusable.flightDate.validation.notInRange'
        },
        flightNumber: {
            between: 'reusable.flightNumber.validation.between',
            flightNumberInvalid: 'reusable.flightNumber.validation.invalid',
            required: 'reusable.flightNumber.validation.required'
        },
        contactFirstName: {
            required: 'reusable.firstName.validation.required',
            alphaWithSpaces: 'reusable.firstName.validation.alphaWithSpaces'
        },
        contactLastName: {
            required: 'reusable.lastName.validation.required',
            alphaWithSpaces: 'reusable.lastName.validation.alphaWithSpaces',
            minLength: 'reusable.lastName.validation.minLength',
            maxLength: 'reusable.lastName.validation.maxLength'
        },
        email: {
            required: 'reusable.email.validation.required',
            email: 'reusable.email.validation.invalid'
        },
        title: { required: 'reusable.paxTitle.validation.required' },
        originLabel: {
            required: 'reusable.origin.validation.required'
        },
        destinLabel: {
            required: 'reusable.destin.validation.required'
        }
    };
    return PaymentValidationService;
}());
export default PaymentValidationService;
